import { gql } from 'apollo-boost'

const RESOLVE_DISH_REVIEW_TASK = gql`
  mutation resolveDishReviewTask(
    $id: ID!
    $menuId: ID!
    $menuTitlesData: [SaveDishReviewTaskMenuTitleInput!]!
    $uploadedMenuTitlesData: [SaveDishReviewTaskUploadedMenuTitleInput!]
    $uploadedDishesData: [SaveDishReviewTaskUploadedDishInput!]
  ) {
    resolveDishReviewTask(
      id: $id
      menuId: $menuId
      menuTitlesData: $menuTitlesData
      uploadedMenuTitlesData: $uploadedMenuTitlesData
      uploadedDishesData: $uploadedDishesData
    ) {
      id
    }
  }
`

export default RESOLVE_DISH_REVIEW_TASK
